import { ArrayInput, SimpleFormIterator, SelectInput, TextInput, BooleanInput } from "react-admin";
import { FormDataConsumer } from "react-admin";

export function AgendaFormQuestions() {
  return (
    <ArrayInput source="questions" label={null}>
      <SimpleFormIterator>
        <SelectInput
          source="type"
          label="resources.agenda.fields.type"
          choices={[
            { id: 'Text', name: 'Infotekst' },
            { id: 'OpenSingle', name: 'Open vraag (kort antwoord)' },
            { id: 'Open', name: 'Open vraag  (lang antwoord)' },
            { id: 'MultipleChoice', name: 'Multiple-choice' },
            { id: 'Boolean', name: 'Ja/Nee' },
            { id: 'CheckboxList', name: 'Checkbox lijst' },
          ]}
        />
        <TextInput source="title" label="resources.agenda.fields.title" />

        <FormDataConsumer>
          {({ getSource, scopedFormData }) => {
            if (scopedFormData?.type === 'Text')
              return <TextInput source={getSource('text')} label="resources.agenda.fields.text" multiline />;

            if (scopedFormData?.type === 'Open') return (
              <>
                <BooleanInput source={getSource('mandatory')} label="resources.agenda.fields.mandatory" />
                <TextInput source={getSource('maximumLength')} label="resources.agenda.fields.maximum_length" />
              </>
            );
            if (scopedFormData?.type !== 'MultipleChoice' && scopedFormData?.type !== 'CheckboxList') return (<BooleanInput source={getSource('mandatory')} label="resources.agenda.fields.mandatory" />);

            return (
              <>
                <ArrayInput
                  source={getSource('options')}
                  label={scopedFormData.options?.length > 0 ? 'resources.agenda.fields.options' : ''}
                >
                  <SimpleFormIterator>
                    <TextInput source={'text'} label="resources.agenda.fields.option" />
                  </SimpleFormIterator>
                </ArrayInput>
                <BooleanInput source={getSource('mandatory')} label="resources.agenda.fields.mandatory" />
              </>
            );
          }}
        </FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  )
}